import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sidebar-brand" }
const _hoisted_2 = { class: "sidebar-nav" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("li", { class: "nav-title" }, "Planer Ślubu", -1)
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inlineSvg = _resolveComponent("inlineSvg")!
  const _component_BIconCalendarFill = _resolveComponent("BIconCalendarFill")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BIconHourglassSplit = _resolveComponent("BIconHourglassSplit")!
  const _component_BIconPeopleFill = _resolveComponent("BIconPeopleFill")!
  const _component_CSidebar = _resolveComponent("CSidebar")!

  return (_openBlock(), _createBlock(_component_CSidebar, {
    position: "fixed",
    unfoldable: _ctx.sidebarUnfoldable,
    visible: _ctx.sidebarVisible,
    onVisibleChange: _cache[1] || (_cache[1] = 
      (visible) => _ctx.$store.commit('theme/updateSidebarVisible', visible)
    )
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_inlineSvg, {
          src: require('@/assets/brand/logo-slub-symboliczny-white.svg'),
          alt: "Logo Planer Ślubu",
          class: "sidebar-brand-full",
          height: "45"
        }, null, 8, ["src"]),
        _createVNode(_component_inlineSvg, {
          src: require('@/assets/brand/logo-slub-symboliczny-white.svg'),
          alt: "Logo Planer Ślubu",
          class: "sidebar-brand-narrow",
          height: "45"
        }, null, 8, ["src"])
      ]),
      _createElementVNode("ul", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("li", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: { name: 'Calendar' },
            class: _normalizeClass(["nav-link", {
            active: _ctx.$router.currentRoute.value.name === 'Calendar',
          }])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_BIconCalendarFill, { class: "nav-icon" }),
              _createTextVNode(" Kalendarz ")
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createElementVNode("li", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: { name: 'ClientMasterList' },
            class: _normalizeClass(["nav-link", {
            active: _ctx.$router.currentRoute.value.name === 'ClientMasterList',
          }])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_BIconHourglassSplit, { class: "nav-icon" }),
              _createTextVNode(" Oczekujące oferty ")
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createElementVNode("li", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: { name: 'ClientList' },
            class: _normalizeClass(["nav-link", {
            active:
              _ctx.$router.currentRoute.value.name.startsWith('Client') &&
              !_ctx.$router.currentRoute.value.name.startsWith('ClientMaster'),
          }])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_BIconPeopleFill, { class: "nav-icon" }),
              _createTextVNode(" Moje pary ")
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ]),
      _createElementVNode("button", {
        class: "sidebar-toggler d-none d-md-flex",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$store.commit('theme/toggleUnfoldable')))
      })
    ]),
    _: 1
  }, 8, ["unfoldable", "visible"]))
}